import { render, staticRenderFns } from "./SubirVideos.vue?vue&type=template&id=abf32c3c&scoped=true&"
import script from "./SubirVideos.vue?vue&type=script&lang=js&"
export * from "./SubirVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf32c3c",
  null
  
)

export default component.exports